import { createClient } from "@supabase/supabase-js";

export const supabaseUrl = "https://xebnrpwbzpxfpbihxnjj.supabase.co";
export const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlYm5ycHdienB4ZnBiaWh4bmpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5OTY3NDgsImV4cCI6MjA5MTU3Mjc0OH0.n8kZJlf5kjzHVyDifhzutWX8VBWz3hIrwLHlbwcK0nQ";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export function createTransientSupabaseClient() {
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  });
}
